import { render, staticRenderFns } from "./FiltersBar.vue?vue&type=template&id=b2995352&scoped=true"
import script from "./FiltersBar.vue?vue&type=script&lang=js"
export * from "./FiltersBar.vue?vue&type=script&lang=js"
import style0 from "./FiltersBar.vue?vue&type=style&index=0&id=b2995352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2995352",
  null
  
)

export default component.exports